import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SealColorsDefaultsService } from './colors/seal-colors-defaults.service';
import { SiliconeColorsDefaultsService } from './colors/silicone-colors-defaults.service';
import { ColorsDefaultsService } from './colors/colors-defaults.service';
import { HtmlPipe } from './pipes/html.pipe';
import { MaxLengthPipe } from './pipes/max-length.pipe';
import { PlainTextPipe } from './pipes/plain-text.pipe';

@NgModule({
    imports: [CommonModule],
    exports: [
        HtmlPipe,
        MaxLengthPipe,
        PlainTextPipe,
    ],
    declarations: [
        HtmlPipe,
        MaxLengthPipe,
        PlainTextPipe,
    ],
    providers: [ColorsDefaultsService, SealColorsDefaultsService, SiliconeColorsDefaultsService]
})
export class SharedModule {}
